import * as React from 'react';

import { Grid, Paper } from '@mui/material';

import { VideoData } from './VideoData';

export interface IVideoCardProps {
    video: VideoData;
    minHeight: string;
    index: number
}

const VideoCard = (props: IVideoCardProps) => {
    const { video, minHeight, index } = props;

    return (
        <Paper className="video-item-paper" elevation={24}>
            <Grid id={`video-item-paper-${index}`} className="video-item-paper-content-container" container direction="column" >
                <Grid className="video-card-video-thumbnail-container" item>
                    <img id={`video-card-thumbnail-${index}`} src={video.thumbnail} height="100%" width="100%" alt="" />
                    <img
                        className="video-card-thumbnail-big-play-button" 
                        src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='88' height='88' fill='%23d32f2f'%3E%3Cpath fill-rule='evenodd' d='M44 88C19.738 88 0 68.262 0 44S19.738 0 44 0s44 19.738 44 44-19.738 44-44 44zm0-85C21.393 3 3 21.393 3 44c0 22.608 18.393 41 41 41s41-18.392 41-41C85 21.393 66.607 3 44 3zm16.063 43.898L39.629 60.741a3.496 3.496 0 01-3.604.194 3.492 3.492 0 01-1.859-3.092V30.158c0-1.299.712-2.483 1.859-3.092a3.487 3.487 0 013.604.194l20.433 13.843a3.497 3.497 0 01.001 5.795zm-1.683-3.311L37.946 29.744a.49.49 0 00-.276-.09.51.51 0 00-.239.062.483.483 0 00-.265.442v27.685c0 .262.166.389.265.442.1.053.299.118.515-.028L58.38 44.414A.489.489 0 0058.6 44a.49.49 0 00-.22-.413z'/%3E%3C/svg%3E"
                        height="88px"
                        width="88px"
                        alt=""
                        />
                </Grid>
                <Grid className="" item>
                    <Grid id={`video-title-grid-${index}`} className="video-title-grid" container direction="row" columns={4} >
                        <Grid className="video-title-item" item >
                            <p>{video.title}</p>
                        </Grid>
                        <Grid className="" item style={{width: "auto"}} >
                            <div className="video-title-divider-div" />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid id={`video-description-item-${index}`} className="video-description-item" item style={{minHeight: minHeight}} >
                    <p>{video.description}</p>
                </Grid>
            </Grid>
        </Paper>
    )
}

export default VideoCard;